import { Button, Icon, Typography } from 'components'
import { Icons, SSOProps, TypographyTypes } from 'interfaces'
import React from 'react'

export const SSO: React.FC<SSOProps> = ({
	url,
	setOpen,
	setQrCode,
	handleCopy,
	handleNewRequest
}) => {
	return url ? (
		<div className="mt-6">
			<Typography
				className="mb-6"
				fontLeading="15/15"
				type={TypographyTypes.h3}
				title="Connect with Single Sign On"
			/>
			<Typography
				fontLeading="12/15"
				type={TypographyTypes.p}
				className="text-gray-1 !font-normal"
				title="Copy & paste your SSO Link where people can click. Post QR Code where they can scan it."
			/>

			<div className="flex justify-between w-full bg-blue-primary/[0.08] rounded-lg break-all items-center py-0.5 mt-3">
				<Typography
					fontLeading="12/15"
					title={url as string}
					type={TypographyTypes.p}
					className="p-2 !font-normal text-blue-primary truncate"
				/>
				<Button
					onClick={handleCopy}
					iconLeft={Icons.copy}
					color="BlueTransparent"
					className="!min-w-[unset] !border-none"
				/>
			</div>

			<div className="flex items-center justify-end gap-2 mt-7">
				<Button
					label="QR Code"
					iconLeft={Icons.qrCode}
					className="!min-w-[unset] !py-[9px]"
					onClick={() => {
						setOpen(true)
						setQrCode(url as string)
					}}
				/>
			</div>
		</div>
	) : (
		<div className="h-full flex flex-col justify-between mt-8">
			<div className="flex items-center justify-center gap-6">
				<Icon src={Icons.modalAAC} className="w-32" />
				<div>
					<Typography
						className="mb-1"
						title="Not set up yet"
						fontLeading="15/15"
						type={TypographyTypes.h3}
					/>
					<Typography
						fontLeading="12/15"
						type={TypographyTypes.p}
						className="text-gray-1 !font-normal"
						title="Your SSO Link is not set up yet! Please reach support."
					/>
				</div>
			</div>
			<div className="flex justify-end">
				<Button
					label="Request"
					color="Transparent"
					iconLeft={Icons.plus}
					onClick={handleNewRequest}
					className="!max-w-max !py-[9px]"
				/>
			</div>
		</div>
	)
}
